import { UserStatus, UserRole } from './types';

export const roleAsDisplayName = (role: UserRole) => {
  const roles = {
    ADVISOR: 'Advisor',
    SYSTEM_ADMIN: 'System Admin',
    SERVICE_ADMIN: 'Service Admin',
  };
  return roles[role] || role;
};

export const statusAsDisplayName = (status: UserStatus) => {
  const statuses = {
    ACTIVE: 'Active',
    DEACTIVATED: 'Deactivated',
    PENDING: 'Pending',
    ARCHIVED: 'Archived',
  };
  return statuses[status] || status;
};
